import angular from 'angular';
import moment from 'moment';

angular.module('cxRelations').directive('cxRelAuthorization', function() {
  return {
    restrict: 'E',
    template: require('./relAuthorization.html'),
    scope: {
      list: '=data',
      field: '=field',
      relation: '=',
    },
    controller: [
      '$scope',
      'resourceFactorySvc',
      'flySvc',
      '$http',
      'appUrls',
      'Blob',
      'FileSaver',
      'dialogsSvc',
      function($scope, resourceFactorySvc, flySvc, $http, appUrls, Blob, FileSaver, dialogsSvc) {
        var resource = resourceFactorySvc.get('authorization');
        var relationResource = resourceFactorySvc.get('relationLink');
        if (!$scope.list) $scope.list = [];
        $scope.newAuth = null;
        $scope.showErrors = false;
        $scope.today = moment
          .utc()
          .startOf('day')
          .toDate();
        $scope.datepickerOptions = {
          startingDay: 1,
        };

        $scope.setContacts = function(links) {
          $scope.contacts = links.reduce(function(result, item) {
            if (item.isPrincipal && item.target)
              if (item.target.firstName != null) {
                const value = item.target.name + ' ' + item.target.firstName;
                if (result.indexOf(value) === -1) result.push(value);
              } else result.push(item.target.name);
            return result;
          }, []);
        };

        var linksFieldId = $scope.relation.linksFieldId;
        $scope.contacts = [];
        $scope.$watchCollection('relation["' + linksFieldId + '"].value', function(links) {
          if (!links) {
            relationResource.get({ id: $scope.relation.id }).$promise.then(function(result) {
              $scope.setContacts(result);
            });
          } else {
            $scope.setContacts(links);
          }
        });

        $scope.save = function(auth, field, data) {
          //Validation error
          if (typeof data === 'undefined') return '';

          if (angular.equals(auth[field], data)) return false;
          var model = angular.copy(auth);
          model[field] = data;

          return resource.update(model).$promise.then(
            function(result) {
              angular.extend(auth, result);
              flySvc.success('msgConfirmChange');
              return false;
            },
            function(error) {
              flySvc.error(error.data.code, error.data.parameters);
              return '';
            },
          );
        };

        $scope.submitNew = function() {
          if (!$scope.newAuth) return false;

          var model = angular.copy($scope.newAuth);
          $scope.saving = true;
          return resource
            .save(
              {
                id: $scope.relation.id,
              },
              model,
            )
            .$promise.then(
              function(response) {
                flySvc.success('msgNewItemSaved');
                $scope.list.push(response);
                $scope.newAuth = null;
                $scope.saving = false;

                return false;
              },
              function(error) {
                $scope.saving = false;

                flySvc.error(error.data.code, error.data.parameters);
                return '';
              },
            );
        };

        $scope.addNewAuth = function() {
          if ($scope.newAuth) $scope.cancelEdit();
          else {
            if ($scope.newAuthForm) {
              $scope.newAuthForm.$setPristine();
              $scope.newAuthForm.$setUntouched();
            }
            $scope.showErrors = false;
            $scope.newAuth = {
              name: null,
              type: 0,
              signedBy: null,
              date: moment
                .utc()
                .startOf('day')
                .toDate(),
              validUntil: null,
            };
          }
        };

        $scope.remove = function(auth) {
          if (!auth || !auth.id) return;
          auth.removing = true;
          resource.delete(
            {
              id: auth.id,
            },
            function() {
              var idx = $scope.list.indexOf(auth);
              if (idx >= 0) $scope.list.splice(idx, 1);
            },
            function(error) {
              auth.removing = false;
              flySvc.error(error.data.code, error.data.parameters);
            },
          );
        };

        $scope.cancelEdit = function() {
          $scope.newAuth = null;
        };
      },
    ],
  };
});
